// extracted by mini-css-extract-plugin
var _1 = "callCenter__gnO33";
var _2 = "mark__ERIpC";
var _3 = "title__Wbvrm";
var _4 = "value__psXbZ";
export { _1 as "callCenter", _2 as "mark", _3 as "title", _4 as "value" }
export default { "callCenter": _1, "mark": _2, "title": _3, "value": _4 }
